import * as Roles from '../roles'

export const STATIC_PERMISSIONS = {
  [Roles.SUPER_ADMIN]: {
    deviceInfo: true,
    deviceStatus: true,
    isVip: true,
    fname: true,
    lname: true,
    address_1: true,
    postcode: true,
    mobile_number: true,
    customerStatus: true,
    leakbotid: true,
    deviceName: true,
    serialNumber: true,
    tenantName: true,
    leak_status: true,
    message_frequency_sm: true,
    battery_sm: true
  },
  [Roles.ADMIN]: {
    deviceInfo: true,
    deviceStatus: true,
    isVip: true,
    fname: true,
    lname: true,
    address_1: true,
    postcode: true,
    mobile_number: true,
    customerStatus: true,
    leakbotid: true,
    deviceName: true,
    serialNumber: true,
    tenantName: true,
    leak_status: true,
    message_frequency_sm: true,
    battery_sm: true
  },
  [Roles.EXT_OPS]: {
    deviceInfo: true,
    deviceStatus: true,
    isVip: true,
    fname: true,
    lname: true,
    address_1: true,
    postcode: true,
    mobile_number: true,
    customerStatus: true,
    leakbotid: true,
    deviceName: true,
    serialNumber: true,
    tenantName: true,
    leak_status: true,
    message_frequency_sm: true,
    battery_sm: true
  },
  [Roles.MAINTENANCE]: {
    deviceInfo: true,
    deviceStatus: true,
    isVip: false,
    fname: true,
    lname: true,
    address_1: false,
    postcode: true,
    mobile_number: false,
    customerStatus: true,
    leakbotid: true,
    deviceName: true,
    serialNumber: false,
    tenantName: true,
    leak_status: true,
    message_frequency_sm: true,
    battery_sm: true
  },
  [Roles.INSURANCE]: {
    deviceInfo: true,
    deviceStatus: true,
    isVip: false,
    fname: true,
    lname: true,
    address_1: true,
    postcode: true,
    mobile_number: true,
    customerStatus: true,
    leakbotid: true,
    deviceName: true,
    serialNumber: true,
    tenantName: true,
    leak_status: true,
    message_frequency_sm: true,
    battery_sm: true
  },
  [Roles.ANALYTICS]: {
    deviceInfo: false,
    deviceStatus: false,
    isVip: false,
    fname: false,
    lname: false,
    address_1: false,
    postcode: false,
    mobile_number: false,
    customerStatus: false,
    leakbotid: false,
    deviceName: false,
    serialNumber: false,
    tenantName: false,
    leak_status: false,
    message_frequency_sm: false,
    battery_sm: false
  }
}
